import { type ReactNode } from "react";
import { NjbsoftMark } from "./njbsoft-mark";

interface NeutralFrameProps {
  children: ReactNode;
}

/**
 * The frame for a page that belongs to no utility: the brand rule over the
 * canvas and one centered column, NJBSoft's mark above the page's content.
 * No provided-by line: the mark is NJBSoft's own. The frame draws no heading,
 * so the page's content brings its one `h1`.
 */
export function NeutralFrame({ children }: NeutralFrameProps) {
  return (
    <div className="flex min-h-dvh flex-col bg-canvas">
      <div aria-hidden="true" className="h-1 shrink-0 bg-brand-fg" />
      <main className="flex flex-1 flex-col items-center justify-center gap-6 px-4 py-12">
        <NjbsoftMark className="size-12" />
        {children}
      </main>
    </div>
  );
}
